export enum ClothesType {
	GLASSES = 'glasses',
	EARRINGS = 'earrings',
	BRACELET = 'bracelet',
	SUIT = 'suit',
	HAT = 'hat',
	TOP = 'top',
	PANTS = 'pants',
	SHOES = 'shoes',
	MASK = 'mask',
	ARMOR = 'armor',
	WATCHES = 'watches',
	BACKPACK = 'backpack',
	ACCESSORY = 'accessory',
}

/** Кастомный енам компонентов, объединяющий ID компонентов одежды и пропов.
 * (ID для пропов вычисляется так: ID компонента пропа из игры + кол-во компонентов одежды (их 12))
 */
export enum ClothesComponentId {
	HEAD = 0,
	MASK = 1,
	HAIR = 2,
	TORSO = 3,
	LEGS = 4,
	BACKPACK = 5,
	SHOES = 6,
	ACCESSORIES = 7,
	UNDERSHITS = 8,
	ARMORS = 9,
	DECALS = 10,
	TOPS = 11,
	HATS = 12 + 0,
	GLASSES = 12 + 1,
	EARS = 12 + 2,
	WATCHES = 12 + 6,
	BRACELETS = 12 + 7,
}

/** Перевод ID компонента одежды из {@link ClothesComponentId | кастомного} в {@link https://wiki.rage.mp/wiki/Clothes | игровой} */
export function fromCustomToGameComponentId(componentId: ClothesComponentId): number {
	const clothesComponentsCount = 12;
	return componentId % clothesComponentsCount;
}

/** Перевод ID компонента одежды из {@link https://wiki.rage.mp/wiki/Clothes | игрового} в {@link ClothesComponentId | кастомный} */
export function fromGameToCustomComponentId(componentId: number, isProp = false): ClothesComponentId {
	const clothesComponentsCount = 12;

	let customComponentId = componentId;
	if (isProp) {
		customComponentId += clothesComponentsCount;
	}

	if (typeof ClothesComponentId[customComponentId] === 'undefined') {
		throw new Error('Bad game component id provided');
	}

	return customComponentId;
}

export function isClothesItem(id: string): boolean {
	return id.startsWith('ccl_');
}
